"use strict";

baseApp.service('DisplayAdapterService', function () {

    function ReversedHashMap(keys, values) {
        this.keys_values_map = {}
        this.values_keys_map = {}
        if (keys.length !== values.length) {
            console.error("keys and values are not of the same length !")
        }

        this.add = (k, v) => {
            this.keys_values_map[k] = v;
            this.values_keys_map[v] = k;
        }

        keys.forEach( (key, ind) => this.add(key, values[ind]))
        this.keys   = () => Object.keys(this.keys_values_map);
        this.values = () => Object.keys(this.values_keys_map);
        this.get    = k  => this.keys_values_map[k];
        this.getKey = v  => this.values_keys_map[v];
    }

    return {
        displayAdapter: function (values, displayValues) {
            let reversedHashMap = new ReversedHashMap(values, displayValues);
            this.values         = values
            this.displayValues  = displayValues;
            this.value          = displayValue => reversedHashMap.getKey(displayValue);
            this.displayValue   = value        => reversedHashMap.get(value);
        },
    }
})